<template>
  <div>
    <p>Moowle prediction model is based on the current market pricing and takes into accound your property location, condition, size and other variables to estimate its value.</p>
    <md-progress-bar v-if="rentPricePrediction.loading" class="md-accent" md-mode="indeterminate"></md-progress-bar>
    <div v-else-if="rentPricePrediction.err">Cannot predict right now</div>
    <div v-else>
      <b>Monthly rent estimation</b>
      <br />
      <p>Predicted to be between (+/-5%)</p>
      <p class="price-est-value">{{getRentPriceMonthly(rentPricePrediction)}}€</p>

      <p class="moow-subheader">Similar properties</p>
      <p
        lg="12"
        v-for="(prop, index) in getMaxSimilarProperties(rentPricePrediction, 5)"
        :key="index"
      >
      <a :href="prop.url" target="_blank">{{prop.street_name}} {{prop.street_number}}</a>
      </p>
    </div>
  </div>
</template>

<script>
  import { buildRentPricingPredictionRequest } from '../../pricing/factory/pricingFactory.js'

export default {
  name: "autoPricePrediction",
  props: {
    property: {
      type: Object,
      required: true
    },
  },
  data() {
    return {};
  },
  created() {
    this.property?this.getPricePrediction(this.property):void 0;
  },
  computed: {
    rentPricePrediction() {
      return this.$store.getters.rentPricePrediction;
    },
  },
  methods: {
    getMaxSimilarProperties(pricePrediction, maxNr) {
      if(pricePrediction && pricePrediction.similarProperties) return pricePrediction.similarProperties.slice(0, maxNr);
      return ""
      // return pricePrediction.similarProperties.slice(0, maxNr);
    },
    getRentPriceMonthly(pricePrediction) {
      const predictionValue = parseFloat(pricePrediction.price);
      const delta = (predictionValue * 5) / 100;
      var min = predictionValue - delta;
      var max = predictionValue + delta;
      return min.toFixed(0) + " - " + max.toFixed(0);
    },
    getPricePrediction(property) {
      const requestBuilder = buildRentPricingPredictionRequest(
        property
      );
      if (requestBuilder.success) {
        this.$store.dispatch("setRentPricePrediction", requestBuilder.result);
      } else {
        this.$store.commit("SET_RENT_PRICE_PREDICTION", {
          err: "Cannot predict price"
        });
      }
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../assets/styles/global.css";

.price-est-value {
  font-size: 22px;
  font-weight: 400;
  color: #fc5226;
}

#desc {
  background-color: #fafafa;
}

.checkBtn {
  opacity: 0;
  outline: none;
  position: absolute;
  margin: 0;
  left: -999px;
}

p {
  color: #757575;
  text-align: left;
  font-size: 14px;
}

.row {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/pricing/autoPricePrediction.vue